import api from './interceptor';

const baseUrl = (appointmentId) => `api/v2/appointments/${appointmentId}/injury-intake`;

export default {
  get: (appointmentId) => api.get(baseUrl(appointmentId)),
  save: (appointmentId, payload) => api.put(baseUrl(appointmentId), payload),
  complete: (appointmentId, payload) => api.post(`${baseUrl(appointmentId)}/complete`, payload),
  bypass: (appointmentId, payload) => api.post(`${baseUrl(appointmentId)}/bypass`, payload || {}),
};
